/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// react library for routing
import {Redirect, Route, Switch, useLocation} from "react-router-dom";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";
import AuthService from "../views/pages/auth/auth.service";
import companyRoutes from "../companyRoutes";
import centerRoutes from "../centerRoutes";

function Admin({ history }) {
  const [sidenavOpen, setSidenavOpen] = React.useState(true);
  const location = useLocation();
  const mainContentRef = React.useRef(null);
  const currentUser = typeof window !== "undefined" ? AuthService.getCurrentUser() : null;
  const routeGroups = React.useMemo(() => {
    const groups = [routes];
    const hasCompanyScope = !!currentUser?.companyId;

    if (currentUser?.role === "center") {
      if (hasCompanyScope) {
        groups.unshift(companyRoutes, centerRoutes);
      } else {
        groups.unshift(centerRoutes);
      }
    } else if (currentUser?.role === "company") {
      groups.unshift(companyRoutes);
    } else {
      groups.push(centerRoutes, companyRoutes);
    }

    return groups;
  }, [currentUser?.companyId, currentUser?.role]);

  React.useEffect(() => {
    const isCheck = typeof window !== 'undefined' ? AuthService.getCurrentUser() : null;
    // console.log('정보', isCheck)
    if (!isCheck) {
      history.push('/auth/login');
    }
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const getBrandText = (path) => {
    for (let routeGroupIndex = 0; routeGroupIndex < routeGroups.length; routeGroupIndex++) {
      const routeGroup = routeGroups[routeGroupIndex];
      for (let i = 0; i < routeGroup.length; i++) {
        if (location.pathname.indexOf(routeGroup[i].layout + routeGroup[i].path) !== -1) {
          return routeGroup[i].name;
        }
      }
    }
    return "Brand";
  };
  // toggles collapse between mini sidenav and normal
  const toggleSidenav = (e) => {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
    }
    setSidenavOpen(!sidenavOpen);
  };
  const getNavbarTheme = () => {
    return location.pathname.indexOf("admin/alternative-dashboard") === -1
      ? "dark"
      : "light";
  };

  return (
    <>
      <Sidebar
        routes={routes}
        centerRoutes={centerRoutes}
        companyRoutes={companyRoutes}
        toggleSidenav={toggleSidenav}
        sidenavOpen={sidenavOpen}
        logo={{
          innerLink: "/",
          imgSrc: require("assets/img/brand/argon-react.png").default,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContentRef}>
        <AdminNavbar
          theme={getNavbarTheme()}
          toggleSidenav={toggleSidenav}
          sidenavOpen={sidenavOpen}
          brandText={getBrandText(location.pathname)}
        />
        <Switch>
          {routeGroups.map((routeGroup, index) => (
            <React.Fragment key={index}>
              {getRoutes(routeGroup)}
            </React.Fragment>
          ))}
          <Redirect from="*" to="/auth/login" />
        </Switch>
      </div>
      {sidenavOpen ? (
        <div className="backdrop d-xl-none" onClick={toggleSidenav} />
      ) : null}
    </>
  );
}

export default Admin;
